import React, { useEffect, useState, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { Link, useNavigate } from "react-router-dom";
import { cloudcheckGoQuicksend } from "../data/cloudCheckDataTest";
import axios from "axios";

import { ICONS, LOGOS } from "../utils/assets";
import AuthenticatedTemplate from "../components/AuthenticatedTemplate";
import { Footer } from "../components/Footer";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import Alert from "../components/Alert";
import ProgressBar from "../components/ProgressBar";
import { PopUp } from "../components/PopUp";
import { getLocalDateAndTime, validateEmail } from "../utils/global";
import { useOrganisationsStore } from "../stores/organisations-store";
import { useServicesStore } from "../stores/options-store";
import { clearLocalStorageItems } from "../utils/global";

export const Congratulations = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { clearOrganisations } = useOrganisationsStore();
  const { clearServices } = useServicesStore();
  const [orderNumber, setOrderNumber] = useState(0);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [loadingCheckVerify, setLoadingCheckVerify] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPopUpMessage, setShowPopUpMessage] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("");
  const [mobileNumber, setMobileNumber] = useState(false);
  const [emailAddress, setEmailAddress] = useState(false);
  const [radioExpand, setRadioExpand] = useState({
    sms: false,
    email: false,
  });
  const [isVerificationSent, setIsVerificationSent] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    const orderID = JSON.parse(sessionStorage.getItem("LS_ORDER_ID") || "0");
    setOrderNumber(orderID);
  }, [orderNumber, instance]);
  useEffect(() => {
    const executeAsyncTasks = async () => {
      try {
        // Execute the functions in sequence if dependent, or concurrently if independent
        await fetchInsertNewOrderLines(); // Step 01
        await fetchUpdatePaymentStatus(); // Step 02
        await fetchInsertPersonalDetails(); // Step 03
      } catch (error) {
        console.error("Error executing async functions:", error);
      }
    };

    executeAsyncTasks();
  }, []); // Empty dependency array means it runs once when the component mounts

  async function populateOrderLineArray() {
    const orderId = JSON.parse(
      localStorage.getItem("LS_ORDER_ID") || "Not found"
    );
    const organisations = JSON.parse(
      localStorage.getItem("LS_ORGANISATIONS_LIST")
    );
    setOrderNumber(orderId);

    const currentDate = getLocalDateAndTime();

    const orderLines = organisations.map((item, index) => ({
      Order_ID: orderId,
      Organisation_ID: item.Organisation_ID,
      Account_ID: item.Organisation_Account_ID,
      Line_Number: index + 1,
      Line_Status: 1,
      Status_Date: currentDate,
      Status_Message: "msg", // This can be dynamic if needed
    }));

    return orderLines;
  }

  const isFetchingOrderLines = useRef(false); // Lock variable

  const fetchInsertNewOrderLines = async () => {
    if (isFetchingOrderLines.current) {
      console.warn("fetchInsertNewOrderLines is already in progress.");
      return;
    }

    isFetchingOrderLines.current = true; // Set the lock

    try {
      const orderID = JSON.parse(sessionStorage.getItem("LS_ORDER_ID")) || 0;

      if (orderID === 0) {
        console.error("Order ID not found");
        return;
      }

      const orderLinesExist = sessionStorage.getItem("LS_ORDER_LINE");
      if (orderLinesExist === null) {
        const linesObjectArray = await populateOrderLineArray();

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/orders/create-order-lines`,
          {
            orderLinesObject: linesObjectArray,
            orderNumber: orderID,
          }
        );

        if (response && response.data) {
          sessionStorage.setItem("LS_ORDER_LINE", JSON.stringify(1));

          fetchUpdatePaymentStatus();
        } else {
          console.error("Failed to create order lines: No response data");
        }
      } else {
        console.log("Order lines already exist in sessionStorage.");
      }
    } catch (error) {
      console.error("Axios error", error.response?.data || error.message);
    } finally {
      isFetchingOrderLines.current = false; // Release the lock
    }
  };

  async function populatePersonalDetails() {
    const lsCustomerId =
      parseInt(sessionStorage.getItem("LS_CUSTOMER_ID")) || 0;

    const LS_DETAILS = JSON.parse(sessionStorage.getItem("LS_DETAILS")) || {};

    const {
      givenNameTo = "",
      middleNameTo = "",
      familyNameTo = "",
      genderToId = 0,
      emailTo = "",
      mobileNumberTo = "",
      addressFromArray = {},
    } = LS_DETAILS;

    const {
      Local_Address_Unit_Number = "",
      Local_Address_Street_Number = "",
      Local_Address_Street_Name = "",
      Local_Address_Suburb = "",
      Local_Address_City = "",
      Local_Address_State_Region = "",
      Local_Address_Country = "",
      Local_Address_Post_Code = "",
    } = addressFromArray;

    let personalDetailsObject = {
      Customer_ID: lsCustomerId,
      Given_Name: givenNameTo,
      Middle_Name: middleNameTo,
      Surname: familyNameTo,
      Gender: parseInt(genderToId) || 3, // Ensure gender is an integer
      Marital_Status: 1, // Default value (can be dynamic)
      Date_Of_Birth: "", // Placeholder value, should be dynamic
      Id_Type: 1, // Placeholder value, should be dynamic
      Id_Value: "",
      Id_Value_Extra: "",
      Id_Expiry_Date: "", // Placeholder expiry date
      Email: emailTo,
      Mobile_Number: mobileNumberTo,
      Res_Phone_Number: "",
      Work_Phone_Number: "",
      Res_Address_Building_Name: "", // Left blank as per original code
      Res_Address_Unit_Number: Local_Address_Unit_Number,
      Res_Address_Street_Number: Local_Address_Street_Number,
      Res_Address_Street_Name: Local_Address_Street_Name,
      Res_Address_Suburb: Local_Address_Suburb,
      Res_Address_City: Local_Address_City,
      Res_Address_State_Region: Local_Address_State_Region,
      Res_Address_Country: Local_Address_Country,
      Res_Address_Post_Code: Local_Address_Post_Code,
      Post_Address_Same: 1, // Assuming postal address is the same
      Post_Address_Building_Name: "",
      Post_PO_Box: "",
      Post_Address_Unit_Number: "",
      Post_Address_Street_Number: "",
      Post_Address_Street_Name: "",
      Post_Address_Suburb: "",
      Post_Address_City: "",
      Post_Address_State_Region: "",
      Post_Address_Country: "",
      Post_Address_Post_Code: "",
    };
    return personalDetailsObject;
  }

  async function fetchInsertPersonalDetails() {
    try {
      const customerObject = await populatePersonalDetails();

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/create-personal-details`,
        {
          customerObject,
        }
      );

      if (!response) {
        console.log("No data returned from the server.");
      }
    } catch (error) {
      console.error(
        "Error creating personal details:",
        error.response?.data || error.message
      );
    }
  }

  async function fetchUpdatePaymentStatus() {
    try {
      const orderID =
        parseInt(JSON.parse(sessionStorage.getItem("LS_ORDER_ID"))) || 0;

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/orders/update-payment-status`,
        {
          orderID,
          paymentStatus: 3, // Fully paid
          paymentType: 1,
        }
      );

      if (!response?.data) {
        console.log("No data returned from the server.");
      }
    } catch (error) {
      console.error(
        "Error updating payment status:",
        error.response?.data || error.message
      );
    }
  }

  useEffect(() => {
    if (!isVerificationSent || timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          setIsVerificationSent(false);
          return 0;
        } else {
          return prev - 1;
        }
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isVerificationSent]);

  const fetchCloudCheckIdentity = async () => {
    setLoadingVerify(true);
    try {
      const customerInfo = JSON.parse(
        sessionStorage.getItem("LS_CUSTOMER_INFO")
      );
      const sendingChannel = radioExpand.email
        ? "emailAddress"
        : "mobileNumber";
      const value =
        sendingChannel === "emailAddress" ? emailAddress : mobileNumber;

      const checkIDdata = cloudcheckGoQuicksend(
        customerInfo.displayName,
        sendingChannel,
        value
      );

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/identity/identity-cloudcheck`,
        {
          checkIDdata,
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response && response.data) {
        showPopUpSuccess();
        setIsVerificationSent(true);
        setTimer(30);
        sessionStorage.setItem(
          "LS_RECIPIENT_TOKEN",
          response.data.recipientToken
        );
      } else {
        console.log("Received empty response");
        showPopUpError();
      }
    } catch (error) {
      showPopUpError(error.response?.data?.error);
      console.error("Request failed:", error.response?.data || error.message);
    } finally {
      setLoadingVerify(false);
    }
  };

  const fetchCloudCheckResult = async () => {
    setLoadingCheckVerify(true);
    try {
      const recipientToken = sessionStorage.getItem("LS_RECIPIENT_TOKEN");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/identity/identity-cloudcheck-result`,
        {
          recipientToken,
        }
      );

      if (response.data?.successful === "Yes") {
        navigate("/dashboard-return");
        clearLocalStorage();
      } else {
        showPopUpError("Identity could not be verified. Please try again.");
      }
    } catch (error) {
      showPopUpError(error.response?.data?.error);
      console.error(
        "Request failed:",
        error.response?.data ||
          error.message ||
          "There was an error retrieving the identity. Please try again."
      );
    } finally {
      setLoadingCheckVerify(false);
    }
  };

  const showPopUpSuccess = () => {
    setShowPopUpMessage(true);
    const contactMethod = radioExpand.email ? "email address" : "mobile number";
    setPopUpTitle("Success");
    setPopUpMessage(
      `The link has successfully been sent to your ${contactMethod}.`
    );
  };

  const showPopUpError = (message) => {
    setShowPopUpMessage(true);
    setPopUpTitle("Error");
    setPopUpMessage(
      message || "There was an error sending the link. Please try again."
    );
  };

  const clearInputError = (name, value) => {
    const errorKey = name;

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value !== "") {
        delete newErrors[errorKey];
      }
      return newErrors;
    });
  };

  const validateFields = () => {
    let isValid = true;
    let newErrors = {};

    if (radioExpand.sms === false && radioExpand.email === false) {
      newErrors["verificationType"] = "Please select a verifcation option.";
      isValid = false;
    }

    if (radioExpand.sms && !mobileNumber) {
      newErrors["mobileNumber"] = "Please enter your mobile number.";
      isValid = false;
    }

    if (radioExpand.email && !emailAddress) {
      newErrors["emailAddress"] = "Please enter your email address.";
      isValid = false;
    }

    if (radioExpand.email && emailAddress.length > 0) {
      const isValidEmail = validateEmail(emailAddress);
      if (!isValidEmail) {
        newErrors["emailAddress"] = "Please enter a valid email address.";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleRadio = async (value) => {
    setRadioExpand({
      sms: value === "sms",
      email: value === "email",
    });

    clearInputError("verificationType", value);
  };

  const sendVerification = async () => {
    const isValid = validateFields();

    if (!isValid) return;

    fetchCloudCheckIdentity();
  };

  const clearLocalStorage = () => {
    clearLocalStorageItems();
    clearOrganisations();
    clearServices();
  };

  const handleVerifiedIdentity = async () => {
    // await fetchCloudCheckResult();
    clearLocalStorage();
    navigate("/dashboard-return");
  };

  return (
    <>
      <AuthenticatedTemplate>
        <PopUp
          open={showPopUpMessage}
          title={popUpTitle}
          text={popUpMessage}
          onClose={() => setShowPopUpMessage(false)}
        />

        <section className="step__container">
          <div className="step__content">
            <div className="biometric-verification">
              <div className="step__header">
                <img
                  className="logo"
                  src={LOGOS.QUICKMOVE_FLOW}
                  alt="Quickmove logo"
                />
                <div>
                  <h1 className="text-md text-md--variant">
                    Well done. You are almost there!
                  </h1>
                </div>
              </div>

              <p className="small text-neutral">
                Order Number:{" "}
                <span className="semibold text-primary-950">{orderNumber}</span>
              </p>

              <ProgressBar percentage={100} />

              <div className="biometric-verification__content">
                <Alert
                  message="Biometric verification must be completed within 48 hours or your order will be automatically cancelled."
                  closable
                />

                <div className="verification-content__text">
                  <h2 className="text-sm text-primary-950">
                    Biometric ID Verification
                  </h2>
                  <p className="paragraph-md">
                    To verify your identity, we'll send you a secure link via
                    SMS or email. You will need either a New Zealand driver
                    licence or passport to complete the process.
                  </p>
                </div>

                <div className="verification-content__options">
                  <h3 className="paragraph-md semibold paragraph-md--dark">
                    Please select your preferred option below:
                  </h3>

                  <div
                    className={`expandable-document ${
                      radioExpand.sms ? "expandable-document--active" : ""
                    }`}
                  >
                    <div
                      className="expandable-document__header"
                      onClick={() => handleRadio("sms")}
                    >
                      <input
                        type="radio"
                        name="identity"
                        value="driversLicence"
                        checked={radioExpand.sms}
                        readOnly
                      />
                      <h2 className="paragraph-md">SMS</h2>
                    </div>
                    {radioExpand.sms && (
                      <div className="expandable-document__content">
                        <Input
                          label="Mobile Number"
                          placeholder="Enter your mobile number"
                          onInput={(e) => {
                            setMobileNumber(e.target.value);
                            clearInputError("mobileNumber", e.target.value);
                          }}
                        />
                        {errors.mobileNumber && (
                          <p className="paragraph-md text-danger">
                            {errors.mobileNumber}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  <div
                    className={`expandable-document ${
                      radioExpand.email ? "expandable-document--active" : ""
                    }`}
                  >
                    <div
                      className="expandable-document__header"
                      onClick={() => handleRadio("email")}
                    >
                      <input
                        type="radio"
                        name="identity"
                        value="driversLicence"
                        checked={radioExpand.email}
                        readOnly
                      />
                      <h2 className="paragraph-md">Email</h2>
                    </div>
                    {radioExpand.email && (
                      <div className="expandable-document__content">
                        <Input
                          label="Email"
                          placeholder="Enter your email"
                          onInput={(e) => {
                            setEmailAddress(e.target.value);
                            clearInputError("emailAddress", e.target.value);
                          }}
                        />
                        {errors.emailAddress && (
                          <p className="paragraph-md text-danger">
                            {errors.emailAddress}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  {errors.verificationType && (
                    <p className="paragraph-md text-danger">
                      {errors.verificationType}
                    </p>
                  )}
                </div>

                <div className="action-buttons">
                  <Button
                    variant="primary"
                    icon={timer === 0 ? ICONS.SETA_ICON : undefined}
                    loading={loadingVerify}
                    disabled={timer > 0}
                    onClick={() => sendVerification()}
                  >
                    {timer > 0 ? `Resend in ${timer}s` : "Send"}
                  </Button>
                </div>

                <div>
                  <h3 className="paragraph-md semibold paragraph-md--dark">
                    Already completed your verification?
                  </h3>
                  <p className="paragraph-md">
                    Confirm below so we can take you to the dashboard.
                  </p>
                </div>

                <div className="biometric-verification__buttons">
                  <Link to="/dashboard-return" className="w-100">
                    <Button
                      onClick={() => clearLocalStorage()}
                      variant="outlined"
                      width="100%"
                    >
                      I will verify within 48 hours
                    </Button>
                  </Link>
                  <Button
                    onClick={() => handleVerifiedIdentity()}
                    loading={loadingCheckVerify}
                    variant="outlined"
                    width="100%"
                  >
                    I have verified my identity
                  </Button>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
